'use client';

import '@ui5/webcomponents/dist/StepInput.js';
import { ValueState } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `StepInput` consists of an input field and buttons with icons to increase/decrease the value with the predefined step.
 *
 * The user can change the value of the component by pressing the increase/decrease buttons, by typing a number directly, by using the keyboard up/down and page up/down, or by using the mouse scroll wheel. Decimal values are supported.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-StepInput)
 */
const StepInput = withWebComponent('ui5-step-input', ['accessibleName', 'accessibleNameRef', 'max', 'min', 'name', 'placeholder', 'step', 'value', 'valuePrecision', 'valueState'], ['disabled', 'readonly', 'required'], ['valueStateMessage'], ['change']);
StepInput.displayName = 'StepInput';
StepInput.defaultProps = {
  step: 1,
  value: 0,
  valuePrecision: 0,
  valueState: ValueState.None
};
export { StepInput };